module.exports = __webpack_public_path__ + "static/media/about_2.2d37e8b6.svg";